import GoodwillApplicationBalanceSheet from "./partials/GoodwillApplicationBalanceSheet"
import { connect } from "react-redux";

function GoodwillApplication({ appState }) {
  return (
    <>
      <h2 className="sectionHead">Goodwill Application</h2>
      <div className="dashboard-content">
        <div className="data-title-container">
          <div></div>

          <div className="data-title">
            <h6>{appState.companyData.name}</h6>
            <p>Goodwill Application</p>
          </div>
        </div>
      </div>
      <section className="py-0">
        <div className="mt-0 flex justify-center">
          <GoodwillApplicationBalanceSheet />
        </div>
      </section>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    appState: state.appState,
  };
};

export default connect(mapStateToProps, {})(GoodwillApplication);

